import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { IRedirectHomeAccessDenied } from './interfaces';

export const RedirectHomeAccessDenied: React.FC<
  IRedirectHomeAccessDenied
> = (): null => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const didRedirectRef = useRef(false);

  useEffect(() => {
    if (didRedirectRef.current) {
      return;
    }

    didRedirectRef.current = true;

    enqueueSnackbar(t('authorization:portal.permissions.accessDenied'), {
      variant: 'warning',
    });
    navigate('/', { replace: true });
  }, [navigate, t]);

  return null;
};
